import {HgButtonLink} from '../HgButton'
import {HgPricingCardHeading} from './_components/HgPricingCardHeading'
import {HgPricingCardList} from './_components/HgPricingCardList'
import {type HgPricingCardProps} from './types'

export const HgPricingCard = ({
  buttonProps,
  pricingCardSections,
  className,
  disclaimer,
  ...headingProps
}: HgPricingCardProps) => {
  return (
    <article className={className}>
      <HgPricingCardHeading {...headingProps} />
      <HgButtonLink className="w-full" {...buttonProps} />
      <div className="flex flex-col space-y-s5">
        {pricingCardSections.map((section, index) => {
          return <HgPricingCardList key={index} {...section} />
        })}
        {disclaimer && (
          <span className="flex flex-1 items-end text-text-subdued arcadia-body-4">
            {disclaimer}
          </span>
        )}
      </div>
    </article>
  )
}
